/**
 * PanelShell — shared visual container for left/right intelligence panels.
 *
 * Thin cyan-tinted border, translucent lifted surface, monospace tracking
 * label at top, standard padding. Panels compose their body inside.
 */

export function PanelShell({
    title,
    testId,
    right,
    children,
    className = "",
}) {
    return (
        <section
            data-testid={testId}
            className={`qoryn-panel rounded-2xl border-qoryn-borderCyan ${className}`}
            style={{ borderColor: "rgba(0,229,255,0.09)" }}
        >
            <header className="flex items-center justify-between px-4 pt-3 pb-2">
                <div className="flex items-center gap-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-qoryn-cyan" />
                    <span className="font-mono-ui text-[10px] tracking-widest uppercase text-qoryn-textDim">
                        {title}
                    </span>
                </div>
                {right}
            </header>
            <div className="px-4 pb-4">{children}</div>
        </section>
    );
}

export default PanelShell;
